import FeatureSnippetOption from "./FeatureSnippetOption";

export default FeatureSnippetOption;
export { FeatureSnippetOption };
